import { render, staticRenderFns } from "./OrderCardItem.vue?vue&type=template&id=0d56ad50&scoped=true&"
import script from "./OrderCardItem.vue?vue&type=script&lang=js&"
export * from "./OrderCardItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderCardItem.vue?vue&type=style&index=0&id=0d56ad50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56ad50",
  null
  
)

export default component.exports